import { PropsWithChildren } from 'react';

import { Box, Icon, ListRow, Separator } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

type Props = { to: string; name: string };

export const titleCss = { textDecoration: { _groupHover: 'underline', _groupFocus: 'underline' } };

export const StyledLinkRow: React.FC<PropsWithChildren<Props>> = ({ to, name, children }) => (
  <>
    <Box className="group">
      <SambaAutoLink to={to} css={{ textDecoration: 'none!important' }} aria-labelledby={name}>
        <ListRow css={{ _groupHover: { cursor: 'pointer' } }}>
          {children}
          <ListRow.TrailingAsset>
            <Icon color="icon" name="CaretRight" size="small" />
          </ListRow.TrailingAsset>
        </ListRow>
      </SambaAutoLink>
    </Box>
    <Separator css={{ fullWidthWithInset: 'space.300' }} />
  </>
);
